import React from "react";
import "./TermsAndConditions.css";

export default function TermsAndConditions() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Terms & Conditions</h1>

        <p className="legal-effective">
          <strong>Effective Date:</strong> July 31, 2026
        </p>

        <p>
          Welcome to <strong>NN FIT</strong>, a gym and fitness management
          platform developed and operated by <strong>NN AI Solutions</strong>.
        </p>

        <p>
          By creating an account, subscribing to, or using NN FIT, you
          acknowledge that you have read, understood, and agreed to these Terms
          & Conditions. If you do not agree with these Terms, you must
          discontinue using the platform.
        </p>

        <section>
          <h2>1. About NN FIT</h2>
          <p>
            NN FIT is a Software-as-a-Service (SaaS) platform designed to help
            gyms and fitness businesses manage their operations digitally.
          </p>

          <p>
            Depending on the selected subscription plan, NN FIT may provide
            features including member management, attendance tracking,
            membership plans, trainers, workout plans, diet plans, payments,
            renewal notifications, QR-based attendance, reports, member portals
            and other related services.
          </p>
        </section>

        <section>
          <h2>2. Eligibility</h2>
          <p>
            You must be at least eighteen (18) years of age and legally capable
            of entering into a binding agreement to use NN FIT.
          </p>

          <p>
            By registering, you confirm that the information provided by you is
            accurate, complete and up to date.
          </p>
        </section>

        <section>
          <h2>3. Account Registration</h2>
          <p>
            Gym owners are responsible for maintaining the confidentiality and
            security of their account credentials.
          </p>

          <p>
            You are responsible for all activities performed through your
            account, including activities performed by authorized staff members.
          </p>

          <p>
            You must not share your login credentials with unauthorized persons
            or create fraudulent accounts.
          </p>
        </section>

        <section>
          <h2>4. Gym Owner Responsibilities</h2>
          <p>
            Gym owners are responsible for ensuring that the information entered
            into NN FIT is accurate and lawful.
          </p>

          <p>
            This includes member information, membership plans, payment
            information, trainer information, attendance records and other
            business information entered into the platform.
          </p>

          <p>
            Gym owners are also responsible for obtaining any necessary
            permissions or consent from their members before collecting or
            processing their personal information through the platform.
          </p>
        </section>

        <section>
          <h2>5. Subscription Plans</h2>
          <p>
            NN FIT may provide different subscription plans with different
            features, limits and usage allowances.
          </p>

          <p>
            Features available to a gym may depend on the subscription plan
            selected by the gym owner.
          </p>

          <p>
            NN AI Solutions may modify subscription plans, features, limits or
            pricing in accordance with applicable law and its service policies.
          </p>
        </section>

        <section>
          <h2>6. Free Trial</h2>
          <p>
            Where a free trial is offered, the duration and available features
            will be determined by the applicable trial offer.
          </p>

          <p>
            NN AI Solutions reserves the right to modify, discontinue or limit
            trial offers where reasonably necessary.
          </p>
        </section>

        <section>
          <h2>7. Payments</h2>
          <p>
            Subscription payments may be processed through third-party payment
            providers.
          </p>

          <p>
            Users are responsible for providing accurate billing information and
            completing applicable subscription payments.
          </p>

          <p>
            Payment processing may also be subject to the terms and policies of
            the applicable third-party payment provider.
          </p>
        </section>

        <section>
          <h2>8. Member Data</h2>
          <p>
            Gym owners remain responsible for the member information and other
            business data they enter into NN FIT.
          </p>

          <p>
            Such information may include member names, contact information,
            membership details, attendance records, photographs, payment records
            and other information necessary for operating the gym.
          </p>
        </section>

        <section>
          <h2>9. Data Ownership</h2>
          <p>
            Subject to applicable law and the rights of third parties, gyms
            retain ownership of the business information they submit to NN FIT.
          </p>

          <p>
            NN AI Solutions uses such information to provide, maintain, secure
            and improve the requested services.
          </p>
        </section>

        <section>
          <h2>10. Data Security</h2>
          <p>
            NN AI Solutions takes commercially reasonable measures to protect
            information stored through NN FIT.
          </p>

          <p>
            However, no internet-based service can guarantee absolute security.
            Gym owners are responsible for protecting their account credentials
            and controlling access to their accounts.
          </p>
        </section>

        <section>
          <h2>11. QR Attendance</h2>
          <p>NN FIT may provide QR-based attendance functionality.</p>

          <p>
            Gym owners are responsible for ensuring that QR codes are used
            appropriately and that attendance information recorded through the
            system is accurate.
          </p>
        </section>

        <section>
          <h2>12. Payments and Gym Operations</h2>
          <p>
            NN FIT provides software tools for recording and managing gym
            payments, memberships and related information.
          </p>

          <p>
            Gym owners remain responsible for their actual business
            transactions, pricing, taxes, refunds, membership agreements and
            financial obligations.
          </p>
        </section>

        <section>
          <h2>13. Acceptable Use</h2>
          <p>Users must not:</p>

          <ul>
            <li>
              Attempt unauthorized access to NN FIT or another user's account.
            </li>
            <li>Reverse engineer or copy the software.</li>
            <li>Introduce malicious software or harmful code.</li>
            <li>Interfere with platform security or availability.</li>
            <li>Use NN FIT for unlawful activities.</li>
            <li>Attempt to access data belonging to another gym.</li>
            <li>
              Use the platform to abuse, harass or unlawfully target others.
            </li>
          </ul>

          <p>
            Violations may result in suspension or termination of an account.
          </p>
        </section>

        <section>
          <h2>14. Intellectual Property</h2>
          <p>
            NN FIT, including its software, source code, user interface,
            designs, graphics, branding, documentation, trademarks and related
            intellectual property, remains the property of NN AI Solutions or
            its applicable licensors.
          </p>

          <p>
            Users may not copy, modify, distribute, sell, sublicense, reverse
            engineer or commercially exploit any part of NN FIT without
            appropriate written authorization.
          </p>
        </section>

        <section>
          <h2>15. Third-Party Services</h2>
          <p>
            NN FIT may use third-party services including payment gateways,
            cloud hosting, authentication, storage and other infrastructure
            providers.
          </p>

          <p>
            Third-party services may be governed by their own terms, conditions
            and privacy policies.
          </p>
        </section>

        <section>
          <h2>16. Service Availability</h2>
          <p>
            NN AI Solutions aims to provide reliable access to NN FIT. However,
            temporary interruptions may occur due to maintenance, technical
            problems, internet failures, cloud infrastructure problems, security
            incidents or circumstances beyond reasonable control.
          </p>
        </section>

        <section>
          <h2>17. Suspension and Termination</h2>
          <p>
            NN AI Solutions may suspend or terminate access to NN FIT where
            reasonably necessary, including in cases of fraud, misuse, violation
            of these Terms, security concerns or failure to maintain an
            applicable subscription.
          </p>
        </section>

        <section>
          <h2>18. Limitation of Liability</h2>
          <p>
            To the maximum extent permitted by applicable law, NN AI Solutions
            shall not be responsible for losses resulting from gym operations,
            inaccurate information entered by users, member disputes, business
            decisions, internet failures, third-party service interruptions or
            unauthorized access caused by compromised user credentials.
          </p>
        </section>

        <section>
          <h2>19. Changes to NN FIT</h2>
          <p>
            NN AI Solutions may introduce new features, modify existing
            functionality, improve security, change service limits or
            discontinue features when reasonably necessary.
          </p>
        </section>

        <section>
          <h2>20. Changes to These Terms</h2>
          <p>
            These Terms & Conditions may be updated periodically. Updated
            versions will be published on this page with a revised effective
            date.
          </p>

          <p>
            Continued use of NN FIT after an update may constitute acceptance of
            the revised Terms, subject to applicable law.
          </p>
        </section>

        <section>
          <h2>21. Governing Law</h2>
          <p>
            These Terms shall be governed by and interpreted in accordance with
            the applicable laws of India.
          </p>

          <p>
            Subject to applicable law, disputes relating to these Terms shall be
            subject to the jurisdiction of the competent courts in Telangana,
            India.
          </p>
        </section>

        <section>
          <h2>22. Contact Us</h2>

          <p>
            <strong>NN AI Solutions</strong>
            <br />
            Nizamabad, Telangana, India
            <br />
            Phone: 8688663447
            <br />
            Email: info@nnaisolution.com, info@nnfit.in
            <br />
            Website: nnfit.in, nnaisolution.com
          </p>
        </section>
      </div>
    </div>
  );
}
